import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Users, ArrowRight } from "lucide-react";

/**
 * Sidebar card showing other patients registered under the same mobile number.
 * Renders nothing when the patient has no family members.
 */
export default function FamilyCard({ patientId }) {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get(`/patients/${patientId}/household`);
        setMembers(r.data.members || []);
      } catch (e) { console.debug("[silent]", e); }
      setLoading(false);
    })();
  }, [patientId]);

  if (loading || members.length === 0) return null;

  return (
    <div className="mt-4 bg-white border border-slate-200 rounded-md p-4" data-testid="family-card">
      <div className="flex items-center gap-2">
        <Users size={16} className="text-pink-600" />
        <div className="section-title text-sm">Family ({members.length})</div>
      </div>
      <div className="text-xs text-slate-500 mt-1">
        Other patients registered under this mobile number.
      </div>
      <div className="mt-3 space-y-1">
        {members.map((m) => (
          <Link
            key={m.patient_id}
            to={`/patient/${m.patient_id}`}
            className="flex items-center justify-between p-2 rounded hover:bg-pink-50 text-sm"
            data-testid={`family-member-${m.patient_id}`}
          >
            <div>
              <div className="font-medium truncate">{m.name}</div>
              <div className="text-[11px] text-slate-500 tabular">
                {m.patient_id} · {m.age ? `${m.age}yr` : ""} {m.sex}
              </div>
            </div>
            <ArrowRight size={12} className="text-slate-400" />
          </Link>
        ))}
      </div>
    </div>
  );
}
